import React from 'react';
import ContentLayout from '../ContentLayout';
import RoleContent from './RoleContent';

function ManageRoles() {

    return (
        <ContentLayout>
            <RoleContent/>
        </ContentLayout>
    );

}

export default ManageRoles;
